//
//
//
//
//
//
//
//

import { isReport } from '@/utils/tools';
import { openReport, removeReport } from '@/utils/report';

export default {
  props: {
    type: {
      type: Number,
    },
    res_id: {
      type: Number,
    },
  },
  beforeDestroy() {
    removeReport('report');
  },
  methods: {
    async report() {
      const is_report_value = await isReport({ res_id: this.res_id });
      if (is_report_value) {
        return false;
      }

      console.log('reportreport');
      openReport('report', { res_id: this.res_id, res_type: this.type });
      return true;
    },
  },
};
